export const CONFIG = {
    api : 'https://ownaware.dev.fegno.com/api/v1/' ,
    appName : 'Own Aware' ,
    pageId : 'page' ,
    max_results : 15 
}